require('./static/css/style.css');
const React = require('react');
const Layout = require('./src/layout/layout').default;

export const wrapPageElement = ({ element, props }) => {
    const isHomepage = props.location.pathname === '/';
    return (
        <Layout {...props} isHomepage={isHomepage}>
            {element}
        </Layout>
    );
};

export const onRouteUpdate = ({ location, prevLocation }) => {
    // console.log('new pathname', location)
    // console.log('old pathname', prevLocation ? prevLocation : null)
};

// suppress react warning
// TODO This is a temp fix to suppress deprecation warnings, update all default props and remove this block.
if (process.env.NODE_ENV === 'development') {
    const originalError = console.error;
    console.error = (...args) => {
        if (typeof args[0] === 'string' && args[0].includes('Support for defaultProps will be removed')) {
            return;
        }
        originalError(...args);
    };
}